export const sectionSize = {
  keyColumnWidth: '13rem',
};
